import GemDrawerMenu from "components/common/DrawerMenu";
import { formatDistanceToNow } from "date-fns";
import { useEffect } from "react";

import { Box, Card, CardHeader } from "@mui/material";
import { DataGrid, gridStringOrNumberComparator, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { useGateways, useUser } from "contexts";
// import { GatewayCreationForm } from "components/common";

function formatDistanceDay(date) {
  if (!date) {
    return 'None';
  }

  return formatDistanceToNow(date, { addSuffix: false })
    .replace('about ', '')
    .replace('less than a', '1')
    .replace('minutes', 'mins')
    .replace('minute', 'min');
}

function latestValuesComparator(value1, value2, cellParams1, cellParams2) {
  // console.log("GatewaysPage: latestValuesComparator", value1, value2, cellParams1, cellParams2);
  return gridStringOrNumberComparator(value1, value2, cellParams1, cellParams2);
}

function GatewaysPage() {
  const { context: user_context, register_user } = useUser();
  const { user } = user_context;
  useEffect(() => {
    register_user();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const { dispatch, gateways } = useGateways();

  // let f_map = Object.assign({ "Any Field": { id: "Any Field", type: "Text" }}, gateways.meta_map);
  // let f_list = Array.from(gateways.display_names);

  // const transdevGateway = gateways.gateways.find(gateway => gateway.identifier === "Transdev_QLD_TMR_T0176");
  // console.log("GatewaysPage: Gateway.identifier Transdev_QLD_TMR_T0176", transdevGateway);

  var dateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
  var timeOptions = { hour12: false, hour: '2-digit', minute:'2-digit' };

  const columns = [
    { field: 'identifier', headerName: 'Gateway', width: 350 },
    { field: 'imei', headerName: 'IMEI', width: 170 },
    { field: 'serialNumber', headerName: 'Serial Number', width: 190 },
    {
      field: 'almsUri',
      headerName: 'ALMS',
      width: 70,
      renderCell: (params) => {
        return (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            ALMS
          </a>
        );
      },
    },
    // { field: 'health', headerName: 'Health', width: 100 },
    // { field: 'provisioningStatus', headerName: 'Provisioning', width: 120 },
    {
      field: 'vehicle',
      headerName: 'Vehicle',
      width: 150,
      valueGetter: (value, row) => {
        // console.log("GatewaysPage: vehicle value", value, row);
        return row?.vehicle?.identifier;
      },
      renderCell: (params) => {
        return (
          <a href={`vehicle/${params.row.vehicle?.id}`} rel="noopener noreferrer">
            {params.row.vehicle?.identifier}
          </a>
        );
      },
        }, 
        { 
      field: 'positionedAt', 
      type: 'date',
      headerName: 'Positioned At', 
      width: 160,
      valueGetter: (value, row) => { return row?.vehicle?.positionedAt ? new Date(row.vehicle.positionedAt) : null; },
      valueFormatter: (value) => {
        return value ? value.toLocaleDateString('en-AU', dateOptions) + " " + value.toLocaleTimeString('en-AU', timeOptions) : '';
      }
    }, 
    { field: 'latestVehicleValues', headerName: 'Odo Value', width: 170, type: 'text',
      sortComparator: latestValuesComparator,
      // Getter needs to be the date, so we can use it to sort. Value getter will convert to timeago.
      valueGetter: (value, row) => { 
        return row?.vehicle?.latestValues?.odometer?.observed_at ? new Date(row?.vehicle?.latestValues?.odometer?.observed_at) : null; 
      },
      valueFormatter: (value) => {
        return value ? value.toLocaleDateString('en-AU', dateOptions) + " " + value.toLocaleTimeString('en-AU', timeOptions) : '';
      }
         },
        {
      field: 'timeDifference',
      headerName: 'Difference',
      width: 100,
      valueGetter: (value, row) => {
        const latestValuesTime = row?.vehicle?.latestValues?.odometer?.observed_at;
        const positionedAtTime = row?.vehicle?.positionedAt;
        if (latestValuesTime && positionedAtTime) {
          return Math.abs(new Date(latestValuesTime) - new Date(positionedAtTime));
        }
        return null;
      },
      valueFormatter: (value) => {
        if (value !== null) {
          const minutes = Math.floor(value / (1000 * 60));
          return `${minutes} mins`;
        }
        return '';
      },
    },
    { field: 'lastComm', headerName: 'Last Comm', width: 160,
      valueGetter: (value, row) => { 
        return row?.latestValues?.last_comm_date ? new Date(row.latestValues.last_comm_date.value) : null;
      },
      //   const lastComm = row?.latestValues?.last_comm_date?.value;
      //   return lastComm
      // },
      valueFormatter: (value) => {
        return value ? value.toLocaleDateString('en-AU', dateOptions) + " " + value.toLocaleTimeString('en-AU', timeOptions) : '';
      }

    },
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector
          slotProps={{ tooltip: { title: 'Change density' } }}
        />
        <GridToolbarExport
          slotProps={{
            tooltip: { title: 'Export data' },
            button: { variant: 'outlined' },
          }}
        />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  gateways?.gateways?.forEach((gateway) => {
    const latestValues = gateway.latestValues;
    if (latestValues) {
      console.log("GatewaysPage: Gateway.latestValues", latestValues);
    }
  }  );

  return (
    <Box display="flex" width="100%" >
      <GemDrawerMenu />

        <Box
        sx={{ flexGrow: 1, padding: '5px' }}>
        <Card>
          <Box sx={{ backgroundColor: '#07A0C3', width: '100%', padding: '0px' }}>
            <CardHeader title="Gateways" sx={{ height: '60px' }}/>
          </Box>
          <DataGrid
            initialState={{ density: 'compact',
              pagination: { paginationModel: { pageSize: 25 } },

            }}
            rows={gateways.gateways}
            columns={columns}
            pageSize={5}
            // rowsPerPageOptions={[5, 10, 20]}
            // checkboxSelection
            disableSelectionOnClick
            slots={{
              toolbar: CustomToolbar,
            }}
            // pageSizeOptions={[5, 10, 25]}
          />
        {/* <ControlComponent
          style={{ display:"flex", width: "60%", justifyContent: "flex-start", alignItems: "center", padding: "10px" }}
          fields={f_list}
          field_map={f_map}
          control_map={gateways.header}
          on_update={(filters) => {
            dispatch({
              type: "SET_FILTERS",
              payload: filters
            });

            dispatch({
              type: "FILTER_GATEWAYS",
              payload: filters,
            });
          }}
        />
        <GatewayTable /> */}
        </Card>

      </Box>
    </Box>
  );
}

export default GatewaysPage;





